import {
  Directive,
  effect,
  inject,
  Input,
  signal,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService, TokensService } from '@ose/services';

@Directive({
  selector: '[libHasAccess]',
  standalone: true,
})
export class HasAccessDirective {

  private authService = inject(AuthService);
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);


  private scopes = signal<string[]>([]);

  @Input()
  set libHasAccess(value: string | string[]) {
    this.scopes.set(Array.isArray(value) ? value : [value]);
  }

  constructor() {
    const isAuthenticated = this.authService.isAuthenticated;
    if (isAuthenticated) {
      effect(() => {
        this.viewContainer.clear();
        const scopes = this.scopes();
        if (scopes.length === 1 && this.authService.hasScope(scopes[0])) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
    }
  }
}
